<img src="/assets/images/steffenVorWagen.jpg">

<table mat-table [dataSource]="dataSource" matSort class="mat-elevation-z8" matSortActive="productionYear"
    matSortDirection="desc">

    <ng-container matColumnDef="productionYear">
        <th mat-header-cell *matHeaderCellDef mat-sort-header style="font-size: 0.8rem;"> {{ 'references.productionYear' | transloco }} </th>
        <td mat-cell *matCellDef="let element"> {{element.productionYear}} </td>
    </ng-container>

    <ng-container matColumnDef="title">
        <th mat-header-cell *matHeaderCellDef mat-sort-header style="font-size: 0.8rem;"> {{ 'references.title' | transloco }} </th>
        <td mat-cell *matCellDef="let element"> {{element.title}} </td>
    </ng-container>

    <ng-container matColumnDef="director">
        <th mat-header-cell *matHeaderCellDef mat-sort-header style="font-size: 0.8rem;"> {{ 'references.director' | transloco }} </th>
        <td mat-cell *matCellDef="let element"> {{element.director}} </td>
    </ng-container>

    <ng-container matColumnDef="genre">
        <th mat-header-cell *matHeaderCellDef mat-sort-header style="font-size: 0.8rem;"> {{ 'references.genre' | transloco }} </th>
        <td mat-cell *matCellDef="let element"> {{element.genre}} </td>
    </ng-container>

    <ng-container matColumnDef="productionCompany">
        <th mat-header-cell *matHeaderCellDef mat-sort-header style="font-size: 0.8rem;"> {{ 'references.productionCompany' | transloco }} </th>
        <td mat-cell *matCellDef="let element"> {{element.productionCompany}} </td>
    </ng-container>

    <tr mat-header-row *matHeaderRowDef="displayedColumns"></tr>
    <tr mat-row *matRowDef="let row; columns: displayedColumns;"></tr>
</table>